
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/infrastructure/road",
      function () {
        return require("private-next-pages/project/infrastructure/road.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/infrastructure/road"])
      });
    }
  